import { render } from "./Cta1.vue?vue&type=template&id=1479a5f1"
import script from "./Cta1.vue?vue&type=script&lang=js"
export * from "./Cta1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__